import request from "../index.js";

export const systemToken = data => {
    return request({
        url: `/token/`,
        method: "POST",
        data
    });
};

export const systemBalanceOverview = data => {
    return request({
        url: `/balance-overview/`,
        method: "GET",
        data
    });
};

export const systemProfile = data => {
    return request({
        url: `/profile/`,
        method: "POST",
        data
    });
};

export const systemNetWorthCurve = data => {
    return request({
        url: `/net-worth-curve/`,
        method: "GET",
        data
    });
};

export const systemAssetBarChart = data => {
    return request({
        url: `/asset-bar-chart/`,
        method: "GET",
        data
    });
};

export const systemPriceCurve = data => {
    return request({
        url: `/price-curve/`,
        method: "GET",
        data
    });
};

export const systemHistPerf = data => {
    return request({
        url: `/hist-perf/`,
        method: "GET",
        data
    });
};

export const systemFundElements = data => {
    return request({
        url: `/fund-elements/`,
        method: "GET",
        data
    });
};

export const systemInletWithdrawal = data => {
    return request({
        url: `/inlet-withdrawal/`,
        method: "GET",
        data
    });
};

export const systemChangePassword = data => {
    return request({
        url: `/change-password/`,
        method: "POST",
        data
    });
};

export const systemMonthlyReport = data => {
    return request({
        url: `/monthly-report/`,
        method: "GET",
        data
    });
};
